import { cpOrderFormApiConnector } from 'apiConnector/secondary-market/cp-order/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { secondaryMarketCpOrderInitFormFetchedThunk } from 'state/secondaryMarket/cpOrder/cpOrderForm/cpOrderForm.thunks';
import { secondaryMarketCpOrderInitFormFetchedFailed } from 'state/secondaryMarket/cpOrder/referential/product/product.actions';
import type { EpicWithThunk } from 'state/state.common';
import { mapErrorKind } from 'utils/errors/errors';
import type { HttpError } from 'utils/http/httpClient.model';

import { getTabRemoved$ } from '../utils';

export function initCpOrderFormEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { reload } = cpOrderFormApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_CP_ORDER_INIT_FORM_FETCH_REQUESTED'),
      mergeMap(({ bcsProductKey, tabId, tradeWay, client, custodian }) =>
        reload({ bcsProductKey, tradeWay, client, custodian }).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(response => secondaryMarketCpOrderInitFormFetchedThunk(tabId, response)),
          catchError((err: HttpError) => {
            return of(secondaryMarketCpOrderInitFormFetchedFailed(tabId, err?.payload?.message, mapErrorKind(err)));
          }),
        ),
      ),
    );
  };
}
